/**
 * @generated SignedSource<<0878d1f00581d7c186d869165ba07f85>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddCanIfUnlockedStartContentConfigInput = {
  clientMutationId?: string | null;
  contentId: string;
};
export type startContentConfigEditor_addCanIfUnlockedStartContentConfigAdminMutation$variables = {
  input: AddCanIfUnlockedStartContentConfigInput;
};
export type startContentConfigEditor_addCanIfUnlockedStartContentConfigAdminMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly addCanIfUnlockedStartContentConfig: {
        readonly clientMutationId: string | null;
        readonly content: {
          readonly " $fragmentSpreads": FragmentRefs<"startContentConfigEditor_TreeNodeFragment">;
        };
      } | null;
    };
  };
};
export type startContentConfigEditor_addCanIfUnlockedStartContentConfigAdminMutation = {
  response: startContentConfigEditor_addCanIfUnlockedStartContentConfigAdminMutation$data;
  variables: startContentConfigEditor_addCanIfUnlockedStartContentConfigAdminMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientMutationId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "startContentConfigEditor_addCanIfUnlockedStartContentConfigAdminMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddCanIfUnlockedStartContentConfigPayload",
                "kind": "LinkedField",
                "name": "addCanIfUnlockedStartContentConfig",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "startContentConfigEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "startContentConfigEditor_addCanIfUnlockedStartContentConfigAdminMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "AddCanIfUnlockedStartContentConfigPayload",
                "kind": "LinkedField",
                "name": "addCanIfUnlockedStartContentConfig",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "typeDefinition",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "startConfigs",
                                "plural": true,
                                "selections": [
                                  (v4/*: any*/),
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "configType",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "days",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "CanNDaysAfterStartingTreeStartContentConfig",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ELearningContentTypeDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "393e7af37ca810a3db78c8cf8533cda0",
    "id": null,
    "metadata": {},
    "name": "startContentConfigEditor_addCanIfUnlockedStartContentConfigAdminMutation",
    "operationKind": "mutation",
    "text": "mutation startContentConfigEditor_addCanIfUnlockedStartContentConfigAdminMutation(\n  $input: AddCanIfUnlockedStartContentConfigInput!\n) {\n  Admin {\n    Tree {\n      addCanIfUnlockedStartContentConfig(input: $input) {\n        clientMutationId\n        content {\n          ...startContentConfigEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment startContentConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  typeDefinition {\n    __typename\n    ... on ELearningContentTypeDefinition {\n      startConfigs {\n        __typename\n        id\n        configType\n        ... on CanNDaysAfterStartingTreeStartContentConfig {\n          days\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f1bbd88e2138cc8175bbdf5906fd7b74";

export default node;
